<div class="content-wrapper">
    <div class="container-xxl flex-grow-1">
        <div class="authentication-wrapper authentication-basic container-p-y">
            <div class="authentication-inner" style="width: 35rem;">
                <div class="container">
                    <mat-card class="center mt-5 mb-5">
                        <mat-card-title>
                            <h2 class="mt-3 mb-4"><img src="../../../assets/avatars/2.png" style="width: 30px;">
                                Sign In </h2>
                        </mat-card-title>

                        <mat-card-content>
                            <form [formGroup]="loginForm" (ngSubmit)="login()" method="post">
                                <div class="row" style="padding: 2%;">
                                    <div class="col-md-12">
                                        <label for="UserName" class="form-label">Email </label>
                                        <mat-form-field appearance="outline" style="width: 100%;">
                                            <mat-label>Enter your email</mat-label>
                                            <input matInput type="text" formControlName="UserName" name="UserName"
                                                id="UserName"
                                                [ngClass]="{ 'is-invalid': submitted && forms.UserName.errors }"
                                                required autofocus />
                                            <mat-error *ngIf="submitted && forms.UserName.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="forms.UserName.errors.required">Email is required</div>
                                                <div *ngIf="forms.UserName.errors.email">Email must be a valid email
                                                    address
                                                </div>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <input type="hidden" name="_csrf" [value]="sanitizedCsrfToken" />

                                    <div class="col-md-12">
                                        <label for="Password" class=" form-label">Password</label>
                                        <mat-form-field appearance="outline" style="width: 100%;">
                                            <mat-label>Enter your password</mat-label>
                                            <input matInput [type]="hide ? 'password' : 'text'" name="Password"
                                                formControlName="Password" required id="Password"
                                                [ngClass]="{ 'is-invalid': submitted && forms.Password.errors }">

                                            <button mat-icon-button matSuffix (click)="hide = !hide " type="button"
                                                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                            </button>
                                            <mat-error *ngIf="submitted && forms.Password.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="forms.Password.errors.required">Password is required
                                                </div>
                                                <div *ngIf="forms.Password.errors.minlength"> </div>
                                                <div class="error-text"
                                                    *ngIf="loginForm.get('Password').hasError('passwordStrength')">
                                                    {{loginForm.get('Password').errors['passwordStrength']}}

                                                </div>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-12">
                                        <alert class="notification"></alert>
                                    </div>

                                    <mat-checkbox class="mat-menu-item" color="primary" id="rememberMe"
                                        formControlName="rememberMe">Remember Me</mat-checkbox>
                                </div>
                                <!-- <a href="" class="col-md-5" style = "text-decoration: none;">Forgot Password?</a> -->
                                <button type="submit" class="btn btn-primary d-grid w-100 mt-3 mb-3"> Sign
                                    in</button>

                                <p class="text-center">
                                    <span>New User? </span>
                                    <a href="/#/registration" style="text-decoration: none;">
                                        <span>Create an account</span>
                                    </a>
                                </p>
                                <p class="text-center">
                                    <a href="/#/forgotPassword" style="text-decoration: none;">
                                        <span>Forgot Password?</span>
                                    </a>
                                </p>
                            </form>

                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
    <!-- </div> -->

    <div id="loadingspinner" *ngIf="isLoading">
        <div class="spinner">
            <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
        </div>
    </div>